import { createListenerMiddleware } from '@reduxjs/toolkit';
import { logger, monitoring } from 'common/services';
import { eventApi } from 'store/apis/event';
import { selectUserAccountId } from 'user/api';

import { selectMyCommunity } from '../api/selectors';
import { setActiveCommunityId } from './communitySlice';

import type { RootState } from 'store';

export const communityListener = createListenerMiddleware<RootState>();

communityListener.startListening({
  actionCreator: setActiveCommunityId,
  effect: () => {
    eventApi.util.invalidateTags(['EVENT']);
  },
});

communityListener.startListening({
  actionCreator: setActiveCommunityId,
  effect: ({ payload }, { getState }) => {
    const accountId = selectUserAccountId(getState());
    if (accountId && payload) {
      logger.info(`Setting preferred community to ${payload}`, { communityId: payload });
      monitoring.trackAction('user.change_preferred_community', { communityId: payload });
      localStorage.setItem(`preferredCommunityId-user${accountId}`, payload.toString());
    }
  },
});

communityListener.startListening({
  actionCreator: setActiveCommunityId,
  effect: (_, { getState }) => {
    const community = selectMyCommunity(getState());
    if (community) {
      monitoring.setContext('community', { id: community.id, slug: community.slug });
    }
  },
});
